import './IdCardTeaser.scss';

/** A skeleton teaser of the Briar U student ID — card art + a placeholder
 * avatar + skeleton field bars — shown in the quiz picker's 8th slot (gallery
 * view) to invite the user into the ID-card flow. Percentage-positioned over
 * card.png so it scales with the cell without any JS. */
export default function IdCardTeaser() {
  return (
    <div className="id-teaser" aria-hidden="true">
      <div className="id-teaser__card">
        <img className="id-teaser__bg" src="/img/card.png" alt="" />

        <div className="id-teaser__photo">
          <svg className="id-teaser__avatar" viewBox="0 0 64 70">
            <circle cx="32" cy="22" r="18" />
            <path d="M1 70 Q1 41 32 41 Q63 41 63 70 Z" />
          </svg>
        </div>

        <div className="id-teaser__col id-teaser__col--top">
          {[0, 1, 2].map((i) => (
            <div key={i} className="id-teaser__field">
              <span className="id-teaser__bar id-teaser__bar--label" />
              <span className="id-teaser__bar id-teaser__bar--value" />
            </div>
          ))}
        </div>

        <div className="id-teaser__col id-teaser__col--bottom">
          <span className="id-teaser__bar id-teaser__bar--label" />
          <span className="id-teaser__bar id-teaser__bar--value" />
          <span className="id-teaser__bar id-teaser__bar--value id-teaser__bar--short" />
        </div>
      </div>
    </div>
  );
}
